import React, {useContext, useEffect} from "react";
import {Col, Row, Form} from "react-bootstrap";

import './LearnNumber.css';
import {useIntl} from "react-intl";
import messages from "../../../i18n/messages";
import MaxiIcon from "../../Maxiicon/MaxiIcon";
import CharElm from "../CharElm/CharElm";
import {getLearnedChars} from "../../../utils/LearningUtil";
import {LEARN_CHARACTER_TYPE} from "../../../configuration/configurations";
import {ModalContext} from "../../../contexts/modal/ModalContext";
import {LoadingContext} from "../../../contexts/loading/LoadingContext";
const LearnNumber = () => {
    const intl = useIntl();
    const [, setModalContext] = useContext(ModalContext);
    const [, setLoadingContext] = useContext(LoadingContext);
    const [voiceDisabled, setVoiceDisabled] = React.useState(true);
    const [synthVoice, setSynthVoice] = React.useState(null);
    const [voiceLang, setVoiceLang] = React.useState();
    const [learnedNumber, setLearnedNumber] = React.useState([]);

    const onVoiceLangChange = (event) => {
        setVoiceLang(event.target.value);
    }

    const renderLearnedNumber = () => {
        return learnedNumber.map(char => {
            return (
                <Col xs={4} sm={3} md={2} key={'char_' + char.id}>
                    <CharElm char={char.charWord} voiceDisabled={voiceDisabled} synthVoice={synthVoice}/>
                </Col>
            );
        });
    }

    const getLearnedNumber = async () => {
        try {
            setLoadingContext({
                isLoading: true,
                loadingText: '',
            });
            const response = await getLearnedChars(LEARN_CHARACTER_TYPE.NUMBER);
            if (!response.ok) {
                setModalContext({
                    isShow: true,
                    title: intl.formatMessage(messages.errMsgTitle),
                    content: intl.formatMessage(messages.errMsgServerError),
                    onConfirm: () => {},
                });
            } else if (response.status === 204) {
                // No content
            } else {
                const data = await response.json();
                setLearnedNumber(data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContext({
                isLoading: false,
                loadingText: '',
            });
        }
    }

    useEffect(() => {
        getLearnedNumber();
    }, []);

    useEffect(() => {
        let voiceFilerStr = 'de-DE';
        let firstVoiceChoiceName = 'Shelley';
        let secondVoiceChoiceName = 'Eddy';
        if (voiceLang === 'CN') {
            voiceFilerStr = 'zh-CN';
            firstVoiceChoiceName = 'Tingting';
            secondVoiceChoiceName = 'Yu-shu';
        }
        if (voiceLang !== 'DE' && voiceLang !== 'CN') {
            setSynthVoice(null);
            setVoiceDisabled(true);
            return;
        }

        const synth = window.speechSynthesis;
        let voiceList = synth.getVoices().filter(voice => voice.lang === voiceFilerStr);
        if (voiceList.length === 0) {
            setSynthVoice(null);
            setVoiceDisabled(true);
        } else {
            const idx = voiceList.findIndex(voice => voice.name.indexOf(firstVoiceChoiceName) !== -1);
            if (idx !== -1) {
                setSynthVoice(voiceList[idx]);
            } else {
                const idx2nd = voiceList.findIndex(voice => voice.name.indexOf(secondVoiceChoiceName) !== -1);
                if (idx2nd !== -1) {
                    setSynthVoice(voiceList[idx2nd]);
                } else {
                    setSynthVoice(voiceList[0]);
                }
            }
            setVoiceDisabled(false);
        }

    }, [voiceLang]);

    return (
        <>
            <Row>
                <Col xs={1} sm={1} md={{span: 1, offset: 2}}><MaxiIcon iconName={'faHeadphones'} /></Col>
                <Col xs={11} sm={11} md={6}>
                    <Form>
                        <Form.Select aria-label="Default select example" value={voiceLang} onChange={onVoiceLangChange}>
                            <option>{intl.formatMessage(messages.voiceLangSelectLabel)}</option>
                            <option value="CN">中文</option>
                            <option value="DE">Deutsch</option>
                        </Form.Select>
                    </Form>
                </Col>
            </Row>
            <hr/>
            <Row>
                {renderLearnedNumber()}
            </Row>
        </>
    );
}

export default LearnNumber;